import { useEffect } from "react";
import { compose } from "redux";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Divider from "@material-ui/core/Divider";
import Notes from "../notes/Notes";

import { Organisations } from "../organisations/components/Organisations.Component";
import { Originators } from "../organisations/components/Originators.Component";
import { LenderDepotComponent } from "../depot/components/Depot.Component";
import UserContactData from "./Users.ContactData.Component";
import Withdrawal from "../../../states/users/withdrawal/components/Withdrawal.Component";
import BorrowerWithdrawalComponent from "../borrowerWithdrawal/components/BorrowerWithdrawal.Component";

import SellOrder from "../portfolioSellOrders/Portfolio.Sell.Container";
import { IdentyDisplay } from "./overview/Identity.Display";
import { UsersOverviewConnector } from "../../../services/users/connectors/Users.Overview.Connector";
import { SalesRepressentative } from "./overview/SalesRepresentative";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";
import ConfirmButton from "../../../common/components/ConfirmButton";

export const UserDataComponent = (props) => {
  const checkIfdoingUpdate = (props) => {
    let userAccoutInfo = props.users.accountInfos;
    let userId =
      props.currentUserprops &&
      props.currentUserprops.currentUser &&
      props.currentUserprops.currentUser.Id;
    let ssn;

    if (!userId) return;

    if (
      userAccoutInfo &&
      userAccoutInfo[userId] &&
      userAccoutInfo[userId].ssnFetched
    )
      ssn = userAccoutInfo[userId].data.SSN;

    if (!ssn && !(userAccoutInfo[userId] && userAccoutInfo[userId].ssnFetching))
      props.getSsn(userId);

    if (
      !(userAccoutInfo[userId] && userAccoutInfo[userId].fetched) &&
      !(userAccoutInfo[userId] && userAccoutInfo[userId].fetching)
    )
      props.getUser(userId);
  };
  useEffect(() => {
    checkIfdoingUpdate(props);
  }, [props]);

  useEffect(() => {
    if (props.currentUser) props.getUser(props.currentUser.Id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    props.system.gdprCloseBorrower.sent,
    props.system.gdprCloseInvestor.sent,
  ]);

  useEffect(() => {
    checkIfdoingUpdate(props);
    props.getRepresentatives();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function handleRepressentativeChanged(representativeId, changeDate) {
    if (representativeId == null)
      props.removeRepresentative(props.currentUser.Id, changeDate);
    else
      props.setRepresentative(
        props.currentUser.Id,
        representativeId,
        changeDate,
      );
  }

  let currentUser = props.currentUser;

  if (!currentUser) {
    return "no data";
  }

  return (
    <div>
      <div className="user-panel-box row">
        <div className="col-md-12 user-panel-identity-item">
          <IdentyDisplay {...props} />
        </div>
      </div>
      {currentUser &&
        currentUser.Domain === "Savelend" &&
        props.salesRepresentatives.data !== undefined && (
          <SalesRepressentative
            currentRepresentative={currentUser.SalesRepresentativeId}
            setRepresentative={handleRepressentativeChanged}
            representatives={props.salesRepresentatives.data}
          />
        )}
      <div style={{ clear: "both", height: "5px" }} />
      <Divider />
      {currentUser &&
        currentUser.Domain === "Savelend" &&
        currentUser.LegalEntityType === "NaturalPerson" && (
          <ListItem>
            <ListItemText
              primary={currentUser.PersonIdentified ? "true" : "false"}
              secondary="Person Identified"
            />
            {currentUser.PersonIdentified === false && (
              <ConfirmButton
                label={"Manually identify"}
                action={() => {
                  props.manuallySetIsIdentified(currentUser.PersonId);
                }}
              />
            )}
          </ListItem>
        )}

      <Divider />

      <UserContactData {...props} currentUser={currentUser} />

      <div style={{ clear: "both", height: "5px" }} />

      <Divider />
      {!currentUser ? undefined : currentUser.Domain === "Savelend" &&
        currentUser.LegalEntityType === "NaturalPerson" ? (
        <div>
          <div className="user-panel-box">
            <Organisations
              personId={currentUser.PersonId}
              organisationsData={currentUser.NaturalIdentityData.Organisations}
            />
          </div>
          <Divider />
          <div className="user-panel-box">
            <Originators personId={currentUser.PersonId} />
          </div>
        </div>
      ) : undefined}
      {currentUser && currentUser.Domain === "Savelend" && (
        <div>
          <div className="user-panel-box">
            <LenderDepotComponent
              accountId={currentUser.Id}
              identity={currentUser.Identity}
            />
          </div>
          <div className="user-panel-box">
            <Withdrawal accountId={currentUser.Id} users={props.users} />
          </div>
          <hr />
          <div className="user-panel-box">
            <SellOrder accountId={currentUser.Id} currentUser={currentUser} />
          </div>
        </div>
      )}
      {currentUser && currentUser.Domain === "Loanstep" && (
        <div className="user-panel-box">
          <BorrowerWithdrawalComponent currentUser={currentUser} />
        </div>
      )}
      <div className="user-panel-box">
        <Notes currentUser={currentUser} />
      </div>
      <div style={{ clear: "both" }} />
    </div>
  );
};

const UsersOverviewComponent = (props) => {
  let currentUser = props.currentUser
    ? props.currentUser
    : props.users.currentUser;

  return (
    <Card>
      <CardContent>
        <UserDataComponent
          {...props}
          currentUser={currentUser}
          users={props.users}
        />
        <div style={{ clear: "both", height: "5px" }} />
      </CardContent>
    </Card>
  );
};

export const UserOverview = compose(UsersOverviewConnector)(
  UsersOverviewComponent,
);
